export default __webpack_public_path__ + "e430284.png";